export enum AppFeatures {
  Pipeline = 'Pipeline',
  Dashboard = 'Dashboard',
  Storage = 'Storage',
  TransportMovement = 'TransportMovement',
  Vessel = 'Vessel',
  Reports = 'Reports',
  Passport = 'Passport',
  StockSheet = 'StockSheet',
  VinTracking = 'VinTracking',
  Order = 'Order',
  ShippingPlan = 'ShippingPlan',
  Inspections = 'Inspections',
  Damages = 'Damages',
  DocumentManagement = 'DocumentManagement',
  // Inspection detail page
  Inspection = 'Inspection',
  InspectionDetailCard = 'Inspection.DetailCard',
  InspectionStatusCard = 'Inspection.StatusCard',
  InspectionPointsTable = 'Inspection.StatusCard.PointsTable',
  InspectionGradePoints = 'Inspection.StatusCard.PointsTable.GradePoints',
  InspectionGradeScore = 'Inspection.StatusCard.PointsTable.GradeScore',
  InspectionTnrStatusCard = 'Inspection.TnrStatusCard',
  InspectionTabs = 'Inspection.Tabs',
  InspectionTab = 'Inspection.Tabs.InspectionTab',
  InspectionTabOdometer = 'Inspection.Tabs.InspectionTab.Odometer',
  InspectionTabInspectionNotes = 'Inspection.Tabs.InspectionTab.InspectionNotes',
  InspectionTabMechanicalInspectionNotes = 'Inspection.Tabs.InspectionTab.MechanicalInspectionNotes',
  NotesTab = 'Inspection.Tabs.NotesTab',
  WheelsAndTyresTab = 'Inspection.Tabs.WheelsAndTyresTab',
  ChecklistTab = 'Inspection.Tabs.ChecklistTab',
  DamageTab = 'Inspection.Tabs.DamageTab',
  DamageGridLocation = 'Inspection.Tabs.DamageTab.Location',
  DamageGridPartComp = 'Inspection.Tabs.DamageTab.PartComp',
  DamageGridDamageType = 'Inspection.Tabs.DamageTab.DamageType',
  DamageGridSector = 'Inspection.Tabs.DamageTab.Sector',
  DamageGridSeverity = 'Inspection.Tabs.DamageTab.Severity',
  DamageGridRepairMethod = 'Inspection.Tabs.DamageTab.RepairMethod',
  DamageGridInternalGrade = 'Inspection.Tabs.DamageTab.InternalGrade',
  DamageGridWorkCentre = 'Inspection.Tabs.DamageTab.WorkCentre',
  DamageGridResponsibility = 'Inspection.Tabs.DamageTab.Responsibility',
  DamageGridGradePoints = 'Inspection.Tabs.DamageTab.GradePoints',
  DamageGridLineCost = 'Inspection.Tabs.DamageTab.LineCost',
  DamageGridNote = 'Inspection.Tabs.DamageTab.Note',
  DamageGridFrCount = 'Inspection.Tabs.DamageTab.FrCount',
  DamageGridImages = 'Inspection.Tabs.DamageTab.Images',
  DamageGridTimeline = 'Inspection.Tabs.DamageTab.Timeline',
  DamageGridActions = 'Inspection.Tabs.DamageTab.Actions',
  DocumentsTab = 'Inspection.Tabs.DocumentsTab',
  ChargesTab = 'Inspection.Tabs.ChargesTab',
  ImagesTab = 'Inspection.Tabs.ImagesTab',
  PointInTimeReportsTab = 'Inspection.Tabs.PointInTimeReportsTab',
  EventViewerTab = 'Inspection.Tabs.EventViewerTab',
  MotTab = 'Inspection.Tabs.MotTab',
  Jobs = 'Jobs',
  loadlanes = 'LoadLanes',
  CommandCentre = 'CommandCentre',
  CommandCentreJobAllocation = 'CommandCentre.JobAllocation',
  QuestionnaireResponses = 'QuestionnaireResponses',
  QuestionnaireTemplates = 'QuestionnaireTemplates',
}

export enum DataRuleKey {
  DamageLineApproval = 'DamageLineApproval',
  TnrStatusNotification = 'TnrStatusNotification',
  DefaultLabour = 'DefaultLabour',
  RetailCost = 'RetailCost',
  RejectInspectionNotification = 'RejectInspectionNotification',
  RequireReviewInspectionNotification = 'RequireReviewInspectionNotification',
  HideInspectionsBeforeDate = 'HideInspectionsBeforeDate',
}

export enum DataRuleParamDataType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  DateTime = 'DateTime',
}

export enum AuthorizationStatus {
  Default,
  Approved,
  Rejected,
}

export interface AppFeature {
  code: AppFeatures;
  description: string;
  children: AppFeature[];
}

export interface DataRule {
  id: number;
  ruleKey: string;
  description: string;
  parameters: DataRuleParameter[];
}

export interface DataRuleParameter {
  id: number;
  paramKey: string;
  paramName: string;
  dataType: string;
  isRequired: string;
}
